import { ApiResponse, DataObject } from "@/types";
import { useMutation } from "@tanstack/react-query";
import { RegisterPayload } from "./validation";
import { sendData } from "@/services/api/fetcher";
import { RegisterData } from "./interface";
import { useFormMutation } from "@/hooks/useFormMutation";

// post
export const useRegisterMutation = (
  method: "POST" | "PUT" = "POST",
  id?: number
) => {
  return useFormMutation<
    ApiResponse<DataObject<RegisterPayload>>,
    Error,
    RegisterPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<RegisterPayload>>> => {
      const endpoint = id ? `auth/register/${id}` : "auth/register";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<RegisterPayload>> = await sendData(
        endpoint,
        data,
        method
      );
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Membuat akun..." : "Memperbarui data...",
    successMessage:
      method === "POST" ? "Berhasil membuat akun" : "Data berhasil diperbarui",
  });
};
